"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminBeautifierComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//VARIABLE MODELS
const notification_service_1 = require("./notification.service");
const bidder_service_1 = require("./bidder.service");
const size_service_1 = require("./size.service");
const demand_partner_service_1 = require("./demand-partner.service");
let AdminBeautifierComponent = class AdminBeautifierComponent {
    constructor(_talk, _demand, _size, _bidder) {
        this._talk = _talk;
        this._demand = _demand;
        this._size = _size;
        this._bidder = _bidder;
        this.jsonError = false;
        this.conversionMap = {
            "b": "validBids",
            "qs": "queryString",
            "d": "domain",
            "utms": "utm_source",
            "utmt": "utm_term",
            "utmc": "utm_content",
            "cid": "clientID",
            "dt": "deviceType",
            "cc": "countrycode",
            "et": "executionTime",
            "cs": "connectionSpeed",
            "ai": "adId",
            "auctid": "auctionId",
            "auc": "adUnitCode",
            "ast": "adserverTargeting",
            "hbf": "hb_format",
            "hbpb": "hb_pb",
            "bc": "bidderCode",
            "c": "currency",
            "reqts": "requestTimestamp",
            "rests": "responseTimestamp",
            "s": "size",
            "bbss": "specialStatus",
            "ttr": "timeToRespond",
            "ttl": "timeToLive",
            "bs": "bidStatus",
            "it": "inventoryType",
        };
        this.renameKeys = (payload, conversionMap) => {
            const keyValues = Object.keys(payload).map(key => {
                const newKey = conversionMap[key] || key;
                return { [newKey]: payload[key] };
            });
            return Object.assign({}, ...keyValues);
        };
    }
    conversion() {
        this._bidder.fetchBidderAdUnits().then((bidderAdUnits) => {
            try {
                // Below we grab the info from Bidder360 on Bidders, Sizes, and Demands
                const adUnits = bidderAdUnits;
                const bidderGuidArray = [];
                adUnits.forEach(adUnit => { bidderGuidArray.push([adUnit.guid, adUnit.code]); });
                const sizes = this._size.get();
                const sizeGuidArray = [];
                sizes.forEach((sizeGuid) => {
                    sizeGuidArray.push([sizeGuid.guid, sizeGuid.name]);
                });
                const demands = this._demand.get();
                const demandGuidArray = [];
                demands.forEach((demandGuid) => {
                    demandGuidArray.push([demandGuid.guid, demandGuid.displayName]);
                });
                let parsedPayload = JSON.parse(this.payload);
                let renamedInterior = [];
                const renamedPayload = this.renameKeys(parsedPayload, this.conversionMap);
                const interiorPayload = renamedPayload.validBids; // beginning process to convert inner part of the payload
                interiorPayload.forEach((interiorUnit, index) => {
                    renamedInterior.push(this.renameKeys(interiorUnit, this.conversionMap));
                    renamedInterior[index].adserverTargeting = this.renameKeys(interiorUnit.ast, this.conversionMap);
                    // ad unit code
                    const adUnitCode = renamedInterior[index].adUnitCode;
                    let adUnit;
                    bidderGuidArray.forEach((unitGuid) => {
                        if (unitGuid[0] === adUnitCode) {
                            adUnit = unitGuid[1];
                            renamedInterior[index].adUnitCode = adUnit;
                        }
                    });
                    // size guids
                    const prefix = renamedInterior[index].size;
                    let size;
                    sizeGuidArray.forEach((sizeGuid) => {
                        if (sizeGuid[0] === prefix) {
                            size = sizeGuid[1];
                            renamedInterior[index].size = size;
                        }
                    });
                    // bidder guids
                    const bidderCode = renamedInterior[index].bidderCode;
                    let biddrGuid;
                    demandGuidArray.forEach((demandGuid) => {
                        if (demandGuid[0] === bidderCode) {
                            biddrGuid = demandGuid[1];
                            renamedInterior[index].bidderCode = biddrGuid;
                        }
                    });
                });
                renamedPayload.validBids = renamedInterior;
                this.convertedPayload = parsedPayload; // assign values to the databound variable
                this.outputPayload = renamedPayload; // assign values to the databound variable
            }
            catch (err) { // on error notify the client
                this.jsonError = true;
                this._talk.broadcast(`<h3>There's a problem with your input. Please check and try again.</h3>`);
            }
        });
    }
    reset() {
        this.convertedPayload = '';
        this.outputPayload = '';
        this.jsonError = false;
    }
};
exports.AdminBeautifierComponent = AdminBeautifierComponent;
exports.AdminBeautifierComponent = AdminBeautifierComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-beautifier',
        templateUrl: 'app/admin-beautifier.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        demand_partner_service_1.DemandPartnerService,
        size_service_1.SizeService,
        bidder_service_1.BidderService])
], AdminBeautifierComponent);
//# sourceMappingURL=admin-beautifier.component.js.map